

import React, { useEffect} from "react";

import styled from 'styled-components';

import '../../components/css/common.css';
import { imageDB } from "../../components/imageDB";
import Label from "./Label";
import { useNavigate } from "react-router-dom";
import Fade from 'react-reveal/Fade';

const CategoryviewItem = ({img, name, main}) => {

  const navigate = useNavigate();
  const _handleCategory = () =>{
    navigate("/itemproduct", { state: { CATEGORYINFO: name } });
  }
  return (

    <div onClick={_handleCategory} style={{display: "flex", alignItems: "center", justifyContent:"center",flexDirection:"column", width:"9%", marginTop:10}}>
      <Fade left delay={200}>
      <div style={{display:"flex", flexDirection:"column",marginRight:30}}>
        <div style={{
            borderRadius: 100, width:80, height:80,marginRight:10,marginBottom:10, backgroundColor:"#daebf2"}} className="Box">
          <div style={{position:"relative" }}>
            {
              main== true ? (<img src={img} width={82} style={{borderRadius:100, backgroundColor:"#000"}}  />) :(<img src={img} width={80} style={{borderRadius:100}}  />)
            }
             
          </div>

        </div>
        <div style={{height:30, fontWeight:600, fontSize:14}}>{name}</div>
    </div>
    </Fade>
    </div>
   
 
  
  );
};

export default CategoryviewItem;
